import React from "react"
import { Helmet } from "react-helmet"
import Layout from "../components/layout/layout"
import ServicesHeader from "../components/servicesHeader/servicesHeader"

function ServicesPage() {
  return (
    <Layout>
      <Helmet>
        <title>Junaid Elahi | Services</title>
      </Helmet>
      <div className="page">
        <div id="colorlib-page">
          <ServicesHeader />
        </div>
      </div>
    </Layout>
  )
}

export default ServicesPage
